import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

export const TEXT_SPAN_TYPES = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'subtitle1',
  'subtitle2',
  'body1',
  'body2',
  'caption',
  'button',
  'overline',
];

export const TEXT_SPAN_ALIGN = ['left', 'center', 'right', 'justify', 'inherit'];

export const TEXT_SPAN_COLORS = ['default', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary'];

export const TextSpan = (props) => {
  const {
    align,
    colorOverride,
    gutterBottom,
    type,
    children,
    inline,
    color,
    underline,
    bold,
    paragraph,
    italic,
    style = {},
    className,
    component,
  } = props;

  // const addMargin = [
  //   'h1',
  //   'h2',
  //   'h3',
  //   'h4',
  //   'headline',
  //   'h6',
  // ].includes(type);

  const finalStyle = {
    display: inline ? 'inline-block' : 'block',
    fontStyle: italic ? 'italic' : 'inherit',
    textDecoration: underline ? 'underline' : 'inherit',
    // margin:  addMargin ? '8px 0' : null,
    ...style,
  };
  if (colorOverride) {
    finalStyle.color = colorOverride;
  }

  const Wrapper = bold ? 'b' : 'span';

  return (
    <Typography
      color={color} // should be enum
      style={finalStyle}
      variant={type} // should be enum
      gutterBottom={gutterBottom} // small bottom margin
      align={align} // should be enum
      paragraph={paragraph} // big bottom margin
      component={component}
      className={className}
    >
      <Wrapper>{children}</Wrapper>
    </Typography>
  );
};

TextSpan.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  colorOverride: PropTypes.string,
  bold: PropTypes.bool,
  underline: PropTypes.bool,
  italic: PropTypes.bool,
  inline: PropTypes.bool,
  gutterBottom: PropTypes.bool,
  paragraph: PropTypes.bool,
  align: PropTypes.oneOf(TEXT_SPAN_ALIGN),
  color: PropTypes.oneOf(TEXT_SPAN_COLORS),
  type: PropTypes.oneOf(TEXT_SPAN_TYPES),
  component: PropTypes.string,
  className: PropTypes.string,

  // alternate:     PropTypes.bool,
  // secondary:     PropTypes.bool,
  // colorInherit:  PropTypes.bool,
  // noWrap:        PropTypes.bool,
  // forceWrap:     PropTypes.bool,
  // ellipsis:      PropTypes.bool,
  // paragraph:     PropTypes.bool,
  // weight:        PropTypes.number,
};

TextSpan.defaultProps = {
  align: 'inherit',
  color: 'textPrimary',
  children: '',
  colorInherit: false,
  colorOverride: null,
  gutterBottom: false,
  bold: false,
  italic: false,
  underline: false,
  inline: false,
  noWrap: false,
  forceWrap: false,
  ellipsis: false,
  paragraph: false,
  alternate: false,
  secondary: false,
  style: {},
  // weight:        0,
  type: 'subtitle1',
  component: 'p',
  className: null,
};
